import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react'
import { ReactComponent as Mag } from 'assets/magLogo.svg'
import { selectWarehouses } from './warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Warehouse from './WarehouseComponent'
import { useSelector } from 'react-redux'
import { Autoplay } from 'swiper/modules'
import React, { useRef } from 'react'

import 'swiper/css/autoplay'
import 'swiper/css'

interface SlideShowProps {
  startIndex?: number
  autoplay?: boolean
  showInfo?: boolean
  actionInAllSlides?: boolean
  action: (id: string, status?: warehouse.WarehouseDoorState) => void
}

const SlideShow: React.FC<SlideShowProps> = ({ startIndex = 0, autoplay = false, showInfo = false, actionInAllSlides = false, action }) => {

  const warehouses = useSelector(selectWarehouses)
  const index = useRef(startIndex)

  const { push } = useHistory()
  const { t } = useTranslation('warehouse')

  return (
    <Swiper
      grabCursor
      speed={1000}
      centeredSlides
      slideToClickedSlide
      touchMoveStopPropagation
      modules={[Autoplay]}
      preventClicks={true}
      slidesPerView='auto'
      initialSlide={startIndex}
      autoplay={autoplay ? { delay: 5000 } : false}
      loop={warehouses.length > 1 && ((warehouses.length * 244) > window.innerWidth)}
      onTransitionEnd={({ realIndex }: SwiperClass) => {
        index.current = realIndex
      }}
      onSlideChange={({ realIndex }: SwiperClass) => {
        actionInAllSlides && warehouses[realIndex] && action(warehouses[realIndex]?.objectId)
      }}>

      {warehouses.map(({ objectId, contractId, isShared, name, typeName, clientName, inFuture, dateFrom, clientSurname, doorState, placeName, placeAddress, placeShortAddress }, i) => <SwiperSlide
        key={contractId}
        className='warehouse__slide'>

        {({ isActive }) => <div
          className={`slide${isActive ? ' --selected' : ''}`}
          onClick={() => {
            if (i === index.current) action(objectId, doorState.door)
          }}>

          <Warehouse
            inFuture={inFuture}
            dateFrom={dateFrom}
            doorState={doorState}
          />

          {(isActive && showInfo) && <div className='warehouse__info'>
            <div className='info__text info__title'>
              <div className='--secFont'>{typeName} nr. {name}</div>
              {isShared && <div className='center --gap1'><i className='icon icon--share' /><span>{clientName} {clientSurname}</span></div>}
            </div>
            <div className='info__text info__desc'>
              <div>{placeName}</div>
              <div>{placeAddress}</div>
            </div>
          </div>}

          {(isActive && !showInfo) && <div className='warehouse__info'>
            <div className='info__text info__desc'>
              <div>{placeShortAddress}</div>
            </div>
          </div>}
        </div>}
      </SwiperSlide>)}

      <SwiperSlide className='warehouse__slide commercial center'>
        {({ isActive }) => <div className={`slide${isActive ? ' --selected' : ''}`}>
          <div
            className='warehouse__commercial center'
            onClick={() => push('/categories')}>
            <div className='commercial__title --secFont'>{t('rentANewOne')}</div>
            <Mag />
          </div>
        </div>}
      </SwiperSlide>
    </Swiper>
  )
}

export default SlideShow